// eslint-disable-next-line
export const rootApiUrl = process.env.VUE_APP_ROOT_API || 'http://localhost:10443';
export const requirePayment = process.env.VUE_APP_REQUIRE_PAYMENT === 'true' || false;
